import { useMediaQuery, useTheme } from "@mui/material";

import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalContent from "@/common/components/Modals/AppModalContent";
import AppModalTitle from "@/common/components/Modals/AppModalTitle";

import {
  ContractVisualInspectionComparison,
  ContractVisualInspectionComparisonProps,
} from "./ContractVisualInspectionComparison";

interface Props extends AppModalProps {
  comparisonProps: ContractVisualInspectionComparisonProps;
}

export function ContractVisualInspectionComparisonModal({ comparisonProps, ...modalProps }: Props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <AppModal maxWidth='xl' fullWidth {...modalProps}>
      <AppModalTitle withClose onClose={() => modalProps.onClose?.({}, "escapeKeyDown")}>
        Visual inspection photo comparison
      </AppModalTitle>
      <AppModalContent
        sx={{
          ...(isMobile
            ? {}
            : {
                display: "flex",
                flexDirection: "column",
                height: "80vh",
                overflowY: "hidden",
              }),
        }}
      >
        {modalProps.open && (
          <ContractVisualInspectionComparison
            {...comparisonProps}
            sx={{ height: "100%", overflow: "hidden", ...comparisonProps.sx }}
          />
        )}
      </AppModalContent>
    </AppModal>
  );
}
